import React from "react";

import { NavUserAvatar } from "./NavUserAvatar";
import { NotificationDot } from "./NotificationDot";
import type { MobileTriggerProps } from "./types";

export const LoggedUserNavMobileTrigger: React.FC<MobileTriggerProps> = ({
  trigger,
  name,
  avatarUrl,
  showNotificationDot
}) => (
  <div className="relative">
    {trigger ? (
      <>
        {trigger}
        <span className="-top-4 -right-4 absolute block scale-[0.4] overflow-hidden rounded-full border-4 border-white">
          <NavUserAvatar name={name} avatarUrl={avatarUrl} />
        </span>
      </>
    ) : (
      <NavUserAvatar name={name} avatarUrl={avatarUrl} />
    )}
    {showNotificationDot && (
      <NotificationDot className="bottom-0 left-0 h-3 w-3 ring-2 ring-white" />
    )}
  </div>
);
